import Component from "./FieldRichText";
export default Component;
